import { ref, watch, computed } from "@vue/composition-api";
import store from "@/store";
import { title } from "@core/utils/filter";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import {
  isUserLoggedIn
} from "@/auth/utils";

export default function useModuleList() {
  // Use toast
  const toast = useToast();

  const moduleName = "repportpos";
  const APP_STORE_MODULE_NAME = moduleName;
  const refDataListTable = ref(null);

  const isLoggedIn = isUserLoggedIn();

  // Table Handlers
  const tableColumns = [
    { key: "id", label: "#" },
    { key: "date", label: "Date", sortable: true },
    { key: "sku_branch", label: "Poste Frontalier"},
    { key: "bank", label: "Banque"},
    { key: "bank_account", label: "N° de compte"},
    { key: "amount", label: "Montant (USD)"},
    { key: "bordereau", label: "Bordereau"},
    { key: "camion_remorque", label: "Camion Rem."},
    { key: "camion", label: "Camion"},
    { key: "vehicule_leger", label: "Véh. léger"},
    { key: "total_vehicule", label: "Tot Véh."}, 
];

const datatableArrayData = ref([]);

  const perPage = ref(10);
  const totalAmount = ref("");
  const totalDatas = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);
  const attributeFilter = ref(null);
  const statusFilter = ref(null);
  
  const branchFilter = ref(null);
  const monthFilter = ref(null);
  const dateFilter = ref(null);
  const dateFinaleFilter = ref(null);
  const typeFilter = ref(null);

  let current_rows_count = 0;
  let server_rows_count = 0;

  const dataMeta = computed(() => {
    const localItemsCount = refDataListTable.value
      ? refDataListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalDatas.value,
    };
  });

  const refetchData = () => {
    
     if (isLoggedIn) {
      refDataListTable.value.refresh() 
    }

    /* if(current_rows_count != server_rows_count){
      // si le total actuel est != du total recupere depuis le serveur, on actualise l'actuel compte
      // et on fait reload
      current_rows_count = server_rows_count;
    }else{
      // aucune modification
           
    }     */
  };

  watch(
    [currentPage, perPage, searchQuery, attributeFilter, statusFilter, branchFilter, monthFilter, dateFilter, dateFinaleFilter, typeFilter],
    () => {
      refetchData();
    }
  );


  const fetchModulerepportposes = (ctx, callback) => {
    store
      .dispatch(APP_STORE_MODULE_NAME + "/fetchModulerepportposes", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        attribute: attributeFilter.value,
        status: statusFilter.value,
        branch: branchFilter.value,
        month: monthFilter.value,
        date: dateFilter.value,
        dateFinale: dateFinaleFilter.value,
        type: typeFilter.value,
      })
      .then((response) => {
        // const { data_list, total } = response.data
        var sortedData = response.data.sort(function(a, b) {
          return parseFloat(a.id) - parseFloat(b.id);
        });
        datatableArrayData.value =  sortedData;

        totalDatas.value = response.totalDatas;
        totalAmount.value = response.totalAmount;
        server_rows_count = response.totalDatas;

        callback(response.data);
      })
      .catch((error) => {
        toast({
          component: ToastificationContent,
          props: {
            title: "Erreur chargement liste de données",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveDataTypeVariant = (type) => {
    if (type === "subscriber") return "primary";
    if (type === "manager") return "warning";
    if (type === "maintainer") return "success";
    if (type === "cachier") return "info";
    if (type === "admin") return "danger";
    return "primary";
  };

  const resolveDataTypeIcon = (type) => {
    if (type === "subscriber") return "DataIcon";
    if (type === "manager") return "SettingsIcon";
    if (type === "maintainer") return "DatabaseIcon";
    if (type === "cachier") return "Edit2Icon";
    if (type === "admin") return "ServerIcon";
    return "DataIcon";
  };

  const resolveDataStatusVariant = (status) => {
    if (status === "pending") return "warning";
    if (status === "active") return "success";
    if (status === "inactive") return "secondary";
    return "primary";
  };

  return {
    fetchModulerepportposes,
    tableColumns,
    perPage,
    currentPage,
    totalDatas,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    totalAmount,
    refDataListTable,

    resolveDataTypeVariant,
    resolveDataTypeIcon,
    resolveDataStatusVariant,
    refetchData,

    datatableArrayData,

    // Extra Filters
    attributeFilter,
    statusFilter,
    branchFilter,
    monthFilter,
    dateFilter,
    dateFinaleFilter,
    typeFilter,
  };
}
